import type { Locale as AntdLocale } from "antd/es/locale";
import antdAr from "antd/locale/ar_EG";
import antdEn from "antd/locale/en_US";
import antdRu from "antd/locale/ru_RU";
import antdVi from "antd/locale/vi_VN";
import antdZh from "antd/locale/zh_CN";
import dayjs from "dayjs";
import "dayjs/locale/ar";
import "dayjs/locale/en";
import "dayjs/locale/ru";
import "dayjs/locale/vi";
import "dayjs/locale/zh-cn";
import { DEFAULT_LANGUAGE, RTL_LANGUAGES, SupportedLanguage } from "./index";

interface AppLocale {
  antd: AntdLocale;
  dayjs: string;
}

const APP_LOCALES: Record<SupportedLanguage, AppLocale> = {
  en: { antd: antdEn, dayjs: "en" },
  vi: { antd: antdVi, dayjs: "vi" },
  zh: { antd: antdZh, dayjs: "zh-cn" },
  ru: { antd: antdRu, dayjs: "ru" },
  ar: { antd: antdAr, dayjs: "ar" },
};

export const getAppLocale = (lng: string): AppLocale =>
  APP_LOCALES[lng as SupportedLanguage] ?? APP_LOCALES[DEFAULT_LANGUAGE];

export const isRtl = (lng: string) => RTL_LANGUAGES.includes(lng);

/** Đồng bộ locale mặc định của dayjs (dùng cho định dạng ngày/tháng toàn app). */
export const applyDayjsLocale = (lng: string) => {
  dayjs.locale(getAppLocale(lng).dayjs);
};
